module.exports = __webpack_public_path__ + "static/media/flask.4152478e.svg";